var constants = require('../domain/constants.js');
var brainTreeCardProcessor = require('./processors/brainTreeCardProcessor.js');
var stripeCardProcessor = require('./processors/stripeCardProcessor');
var flipdishPaymentProcessor = require('./processors/flipdishPaymentProcessor');
const commonUtility = require('../domain/commonUtility.js');
const storefrontUtility = require('../domain/storefrontUtility.js');

module.exports.canHandleRefund = function(sale)
{
    return this.getProcessor(sale) != null;
}

module.exports.performRefund = function(sale, amount)
{

    var underlyingProcessor = this.getProcessor(sale);
    if (underlyingProcessor == null)
        return Promise.reject("Failed to find card processor");

    return underlyingProcessor.performRefund(sale, amount);
}

module.exports.getProcessor = function (sale)
{
    const storefront = storefrontUtility.getStorefrontById(sale.storefrontId);
    if (storefront.type == constants.storefrontTypes.MobileApp)
        return brainTreeCardProcessor;

    if (storefront.type == constants.storefrontTypes.WebApp)
        return stripeCardProcessor;

    if ([constants.storefrontTypes.FlipdishKIOSK, constants.storefrontTypes.FlipdishWebApp, constants.storefrontTypes.FlipdishMobileApp].includes(storefront.type))
        return flipdishPaymentProcessor;
}